module.exports = __webpack_public_path__ + "static/media/xk.9c69f3d8.svg";